/**
 * @file enabled=false 时不挂载 tip（无选区逻辑）。
 */
import React, { memo } from 'react';
import SelectionAddKbTip from '../index';

export interface ISelectionAddKbTipGateProps {
  /** 子元素 */
  children: React.ReactNode;
  /** 类名 */
  className?: string;
  /** 是否启用 */
  enabled?: boolean;
}

const SelectionAddKbTipGate: React.FC<ISelectionAddKbTipGateProps> = ({
  children,
  className,
  enabled = false,
}) => {
  if (!enabled) {
    return <div className={className}>{children}</div>;
  }
  return (
    <SelectionAddKbTip className={className}>{children}</SelectionAddKbTip>
  );
};

export default memo(SelectionAddKbTipGate);
